const simpleTextMapping = (data) => {
    const mappedData = {};

    mappedData.paragraph = data.field_component_body[0]?.value;
    mappedData.variation = data.field_text_style[0]?.value;

    return mappedData;
};

export default simpleTextMapping;
